import * as actionTypes from '../actions/actionTypes';

const initialState = { isStartingNewAppFromBusinessTrust: false, isTseu: false };

export default function (state = initialState, action) {
  switch (action.type) {
    case actionTypes.SET_BUSINESS_APP_REDIRECTION: {
      return { ...state, isBusinessAppRedirection: action.isBusinessAppRedirection };
    }

    case actionTypes.SET_TSEU_FLAG_REDIRECTION: {
      return { ...state, isTseu: action.isTseu };
    }

    default:
      return state;
  }
}
